/** 券页切站保留原查询形态，只移除不应跨站传递的身份凭据。 */
export function getCouponProductsSwitchPath(pathname: string, search: string): string | null {
  if (pathname !== '/coupon-products' && pathname !== '/coupon-products/') return null;

  const query = search.startsWith('?') ? search.slice(1) : search;
  const retainedQuery = query
    .split('&')
    .filter((part) => {
      const key = new URLSearchParams(part).keys().next().value?.toLowerCase();
      return key !== 'token' && key !== 'api_token';
    })
    .join('&');

  return `${pathname}${retainedQuery ? `?${retainedQuery}` : ''}`;
}

/** 仅手动选择国家站时携带券页地址；资源接口的映射目标不经过此适配。 */
export function getCountrySiteRedirectUrl(targetUrl: string, currentHref: string): string {
  try {
    const current = new URL(currentHref);
    const path = getCouponProductsSwitchPath(current.pathname, current.search);
    if (path === null) return targetUrl;

    const target = new URL(targetUrl);
    if (target.protocol !== 'https:' && target.protocol !== 'http:') return targetUrl;

    return `${target.origin}${path}${current.hash}`;
  } catch {
    return targetUrl;
  }
}
